import { render, staticRenderFns } from "./distributing.vue?vue&type=template&id=5b563f68&scoped=true&"
import script from "./distributing.vue?vue&type=script&lang=js&"
export * from "./distributing.vue?vue&type=script&lang=js&"
import style0 from "./distributing.vue?vue&type=style&index=0&id=5b563f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b563f68",
  null
  
)

export default component.exports